module.exports = __webpack_public_path__ + "static/media/ss5.00922098.jpg";